import { CSSResultGroup, html, PropertyValues, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-toggle-section.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';

/**
 * The IDB Toggle Section component.
 * @element idb-toggle-section
 * @extends OutlineElement
 */
@customElement('idb-toggle-section')
export class IdbToggleSection extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: Boolean, attribute: 'show-more' })
  showMore: Boolean = false;

  @property({ type: String, attribute: 'indicator' })
  indicator: String = '';

  @property({ type: String, attribute: 'description' })
  description: String = '';


  updateToggle(){
    this.showMore = !this.showMore;

    // const container = this.shadowRoot?.querySelector(
    //   '.sections'
    // ) as HTMLElement;

    // Array.from(container.children).forEach((item) => {
    //   if(this.showMore) {
    //     item.setAttribute('show-more',`${this.showMore}`);
    //   }else{
    //     item.removeAttribute('show-more');
    //   }
    // });
  }

  protected updated(_changedProperties: PropertyValues): void {
    const container = this.shadowRoot?.querySelector(
      '.container'
    ) as HTMLElement;

    const content = Array.from(this.children).length > 0 ? this : container;

    Array.from(content.children).forEach((item) => {
      // remove item from lightdom right away to avoid browser repainting while processing
      container.appendChild(item);

      if(this.showMore) {
        item.setAttribute('show-more',`${this.showMore}`);
      }else{
        item.removeAttribute('show-more');
      }
    });
  }

  render(): TemplateResult {
    return html`
      <div class="info-group show-${this.showMore ? "more":"less"}">
        <div class="indicator">
          <idb-styled-text margin-size="0px"><p><span class="text-lg uppercase font-semibold">${this.indicator}</span></p></idb-styled-text>
        </div>
        <div class="collapse" @click=${this.updateToggle} >
          <outline-icon name="chevron-down" library="bootstrap" size="24px"></outline-icon>
        </div>
      </div>
      <div class="description">
        <idb-styled-text margin-size="0px"><p><span class="text-base">${this.description}</span></p></idb-styled-text>
      </div>
      <div class="container show-${this.showMore ? "more":"less"}">
      </div>
    `;
  }
}
